import { render, staticRenderFns } from "./bannersEdit.vue?vue&type=template&id=ccac7800&"
import script from "./bannersEdit.vue?vue&type=script&lang=js&"
export * from "./bannersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports